/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as VideosRouteImport } from './routes/videos'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TeamsRouteImport } from './routes/teams'
import { Route as StylesRouteImport } from './routes/styles'
import { Route as StartRouteImport } from './routes/start'
import { Route as SignupFlowRouteImport } from './routes/signup-flow'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as OrganizationRouteImport } from './routes/organization'
import { Route as MarketRecapRouteImport } from './routes/market-recap'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LearnRouteImport } from './routes/learn'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as CapturesRouteImport } from './routes/captures'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AgentChatRouteImport } from './routes/agent-chat'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as LearnIndexRouteImport } from './routes/learn.index'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics.index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as VideoShareTokenRouteImport } from './routes/video.$shareToken'
import { Route as ShareShareTokenRouteImport } from './routes/share.$shareToken'
import { Route as SettingsTeamRouteImport } from './routes/settings.team'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as SettingsBillingRouteImport } from './routes/settings.billing'
import { Route as SettingsApiRouteImport } from './routes/settings.api'
import { Route as SettingsAdvancedRouteImport } from './routes/settings.advanced'
import { Route as LearnTeacherRouteImport } from './routes/learn.teacher'
import { Route as LearnStudentRouteImport } from './routes/learn.student'
import { Route as LearnProfileRouteImport } from './routes/learn.profile'
import { Route as LearnParentRouteImport } from './routes/learn.parent'
import { Route as LearnMeRouteImport } from './routes/learn.me'
import { Route as LearnFeedbackRouteImport } from './routes/learn.feedback'
import { Route as LearnShareTokenRouteImport } from './routes/learn.$shareToken'
import { Route as ExtensionPrivacyRouteImport } from './routes/extension.privacy'
import { Route as EmbedShareTokenRouteImport } from './routes/embed.$shareToken'
import { Route as DevelopersQuickstartRouteImport } from './routes/developers_.quickstart'
import { Route as DevelopersKubicleRouteImport } from './routes/developers_.kubicle'
import { Route as ChatConversationIdEnhancedRouteImport } from './routes/chat/$conversationId-enhanced'
import { Route as ChatConversationIdRouteImport } from './routes/chat/$conversationId'
import { Route as CapturesCaptureIdRouteImport } from './routes/captures_.$captureId'
import { Route as BlogShareTokenRouteImport } from './routes/blog.$shareToken'
import { Route as BillingSuccessRouteImport } from './routes/billing.success'
import { Route as AuthExtensionRouteImport } from './routes/auth.extension'
import { Route as AuthActionRouteImport } from './routes/auth.action'
import { Route as AnalyticsShareTokenRouteImport } from './routes/analytics.$shareToken'
import { Route as AdminWebAnalyticsRouteImport } from './routes/admin/web-analytics'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminUpgradeRequestsRouteImport } from './routes/admin/upgrade-requests'
import { Route as AdminTemplatesRouteImport } from './routes/admin/templates'
import { Route as AdminSupportRequestsRouteImport } from './routes/admin/support-requests'
import { Route as AdminOrganizationsRouteImport } from './routes/admin/organizations'
import { Route as AdminLearnersRouteImport } from './routes/admin/learners'
import { Route as AdminLearnRouteImport } from './routes/admin/learn'
import { Route as AdminFrontDoorRouteImport } from './routes/admin/front-door'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as AdminFeaturesRouteImport } from './routes/admin/features'
import { Route as AdminDemoRequestsRouteImport } from './routes/admin/demo-requests'
import { Route as AdminDeliveriesRouteImport } from './routes/admin/deliveries'
import { Route as AdminCustomerHealthRouteImport } from './routes/admin/customer-health'
import { Route as AdminClassesRouteImport } from './routes/admin/classes'
import { Route as AdminBroadcastsRouteImport } from './routes/admin/broadcasts'
import { Route as AdminBillingRouteImport } from './routes/admin/billing'
import { Route as AdminApiCallsRouteImport } from './routes/admin/api-calls'
import { Route as AccountBillingRouteImport } from './routes/account.billing'
import { Route as AnalyticsActorsIndexRouteImport } from './routes/analytics.actors.index'
import { Route as LearnCourseCourseIdRouteImport } from './routes/learn.course.$courseId'
import { Route as ChatConversationIdVideoWorkspaceRouteImport } from './routes/chat/$conversationId/video-workspace'
import { Route as ChatConversationIdSlideWorkspaceRouteImport } from './routes/chat/$conversationId/slide-workspace'
import { Route as ChatConversationIdGalleryRouteImport } from './routes/chat/$conversationId/gallery'
import { Route as AnalyticsActorsActorIdRouteImport } from './routes/analytics.actors.$actorId'
import { Route as ChatConversationIdSlideSlideHashRouteImport } from './routes/chat/$conversationId/slide/$slideHash'

const WaitlistRoute = WaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const VideosRoute = VideosRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsRoute = TeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => rootRouteImport,
} as any)
const StylesRoute = StylesRouteImport.update({
  id: '/styles',
  path: '/styles',
  getParentRoute: () => rootRouteImport,
} as any)
const StartRoute = StartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupFlowRoute = SignupFlowRouteImport.update({
  id: '/signup-flow',
  path: '/signup-flow',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RefundRoute = RefundRouteImport.update({
  id: '/refund',
  path: '/refund',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationRoute = OrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketRecapRoute = MarketRecapRouteImport.update({
  id: '/market-recap',
  path: '/market-recap',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnRoute = LearnRouteImport.update({
  id: '/learn',
  path: '/learn',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingRoute = LandingRouteImport.update({
  id: '/landing',
  path: '/landing',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersRoute = DevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => rootRouteImport,
} as any)
const CapturesRoute = CapturesRouteImport.update({
  id: '/captures',
  path: '/captures',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentChatRoute = AgentChatRouteImport.update({
  id: '/agent-chat',
  path: '/agent-chat',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const LearnIndexRoute = LearnIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LearnRoute,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const VideoShareTokenRoute = VideoShareTokenRouteImport.update({
  id: '/video/$shareToken',
  path: '/video/$shareToken',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareShareTokenRoute = ShareShareTokenRouteImport.update({
  id: '/share/$shareToken',
  path: '/share/$shareToken',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTeamRoute = SettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsApiRoute = SettingsApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAdvancedRoute = SettingsAdvancedRouteImport.update({
  id: '/advanced',
  path: '/advanced',
  getParentRoute: () => SettingsRoute,
} as any)
const LearnTeacherRoute = LearnTeacherRouteImport.update({
  id: '/teacher',
  path: '/teacher',
  getParentRoute: () => LearnRoute,
} as any)
const LearnStudentRoute = LearnStudentRouteImport.update({
  id: '/student',
  path: '/student',
  getParentRoute: () => LearnRoute,
} as any)
const LearnProfileRoute = LearnProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => LearnRoute,
} as any)
const LearnParentRoute = LearnParentRouteImport.update({
  id: '/parent',
  path: '/parent',
  getParentRoute: () => LearnRoute,
} as any)
const LearnMeRoute = LearnMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => LearnRoute,
} as any)
const LearnFeedbackRoute = LearnFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => LearnRoute,
} as any)
const LearnShareTokenRoute = LearnShareTokenRouteImport.update({
  id: '/$shareToken',
  path: '/$shareToken',
  getParentRoute: () => LearnRoute,
} as any)
const ExtensionPrivacyRoute = ExtensionPrivacyRouteImport.update({
  id: '/extension/privacy',
  path: '/extension/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedShareTokenRoute = EmbedShareTokenRouteImport.update({
  id: '/embed/$shareToken',
  path: '/embed/$shareToken',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersQuickstartRoute = DevelopersQuickstartRouteImport.update({
  id: '/developers_/quickstart',
  path: '/developers/quickstart',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersKubicleRoute = DevelopersKubicleRouteImport.update({
  id: '/developers_/kubicle',
  path: '/developers/kubicle',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatConversationIdEnhancedRoute =
  ChatConversationIdEnhancedRouteImport.update({
    id: '/chat/$conversationId-enhanced',
    path: '/chat/$conversationId-enhanced',
    getParentRoute: () => rootRouteImport,
  } as any)
const ChatConversationIdRoute = ChatConversationIdRouteImport.update({
  id: '/chat/$conversationId',
  path: '/chat/$conversationId',
  getParentRoute: () => rootRouteImport,
} as any)
const CapturesCaptureIdRoute = CapturesCaptureIdRouteImport.update({
  id: '/captures_/$captureId',
  path: '/captures/$captureId',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogShareTokenRoute = BlogShareTokenRouteImport.update({
  id: '/blog/$shareToken',
  path: '/blog/$shareToken',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingSuccessRoute = BillingSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => BillingRoute,
} as any)
const AuthExtensionRoute = AuthExtensionRouteImport.update({
  id: '/auth/extension',
  path: '/auth/extension',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthActionRoute = AuthActionRouteImport.update({
  id: '/auth/action',
  path: '/auth/action',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsShareTokenRoute = AnalyticsShareTokenRouteImport.update({
  id: '/$shareToken',
  path: '/$shareToken',
  getParentRoute: () => AnalyticsRoute,
} as any)
const AdminWebAnalyticsRoute = AdminWebAnalyticsRouteImport.update({
  id: '/web-analytics',
  path: '/web-analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUpgradeRequestsRoute = AdminUpgradeRequestsRouteImport.update({
  id: '/upgrade-requests',
  path: '/upgrade-requests',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTemplatesRoute = AdminTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSupportRequestsRoute = AdminSupportRequestsRouteImport.update({
  id: '/support-requests',
  path: '/support-requests',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLearnersRoute = AdminLearnersRouteImport.update({
  id: '/learners',
  path: '/learners',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLearnRoute = AdminLearnRouteImport.update({
  id: '/learn',
  path: '/learn',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFrontDoorRoute = AdminFrontDoorRouteImport.update({
  id: '/front-door',
  path: '/front-door',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeaturesRoute = AdminFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDemoRequestsRoute = AdminDemoRequestsRouteImport.update({
  id: '/demo-requests',
  path: '/demo-requests',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDeliveriesRoute = AdminDeliveriesRouteImport.update({
  id: '/deliveries',
  path: '/deliveries',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomerHealthRoute = AdminCustomerHealthRouteImport.update({
  id: '/customer-health',
  path: '/customer-health',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClassesRoute = AdminClassesRouteImport.update({
  id: '/classes',
  path: '/classes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBroadcastsRoute = AdminBroadcastsRouteImport.update({
  id: '/broadcasts',
  path: '/broadcasts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingRoute = AdminBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AdminRoute,
} as any)
const AdminApiCallsRoute = AdminApiCallsRouteImport.update({
  id: '/api-calls',
  path: '/api-calls',
  getParentRoute: () => AdminRoute,
} as any)
const AccountBillingRoute = AccountBillingRouteImport.update({
  id: '/account/billing',
  path: '/account/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsActorsIndexRoute = AnalyticsActorsIndexRouteImport.update({
  id: '/actors/',
  path: '/actors/',
  getParentRoute: () => AnalyticsRoute,
} as any)
const LearnCourseCourseIdRoute = LearnCourseCourseIdRouteImport.update({
  id: '/course/$courseId',
  path: '/course/$courseId',
  getParentRoute: () => LearnRoute,
} as any)
const ChatConversationIdVideoWorkspaceRoute =
  ChatConversationIdVideoWorkspaceRouteImport.update({
    id: '/video-workspace',
    path: '/video-workspace',
    getParentRoute: () => ChatConversationIdRoute,
  } as any)
const ChatConversationIdSlideWorkspaceRoute =
  ChatConversationIdSlideWorkspaceRouteImport.update({
    id: '/slide-workspace',
    path: '/slide-workspace',
    getParentRoute: () => ChatConversationIdRoute,
  } as any)
const ChatConversationIdGalleryRoute =
  ChatConversationIdGalleryRouteImport.update({
    id: '/gallery',
    path: '/gallery',
    getParentRoute: () => ChatConversationIdRoute,
  } as any)
const AnalyticsActorsActorIdRoute = AnalyticsActorsActorIdRouteImport.update({
  id: '/actors/$actorId',
  path: '/actors/$actorId',
  getParentRoute: () => AnalyticsRoute,
} as any)
const ChatConversationIdSlideSlideHashRoute =
  ChatConversationIdSlideSlideHashRouteImport.update({
    id: '/slide/$slideHash',
    path: '/slide/$slideHash',
    getParentRoute: () => ChatConversationIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/agent-chat': typeof AgentChatRoute
  '/analytics': typeof AnalyticsRouteWithChildren
  '/billing': typeof BillingRouteWithChildren
  '/captures': typeof CapturesRoute
  '/developers': typeof DevelopersRoute
  '/landing': typeof LandingRoute
  '/learn': typeof LearnRouteWithChildren
  '/login': typeof LoginRoute
  '/market-recap': typeof MarketRecapRoute
  '/organization': typeof OrganizationRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/refund': typeof RefundRoute
  '/settings': typeof SettingsRouteWithChildren
  '/signup-flow': typeof SignupFlowRoute
  '/start': typeof StartRoute
  '/styles': typeof StylesRoute
  '/teams': typeof TeamsRoute
  '/terms': typeof TermsRoute
  '/videos': typeof VideosRoute
  '/waitlist': typeof WaitlistRoute
  '/account/billing': typeof AccountBillingRoute
  '/admin/api-calls': typeof AdminApiCallsRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/broadcasts': typeof AdminBroadcastsRoute
  '/admin/classes': typeof AdminClassesRoute
  '/admin/customer-health': typeof AdminCustomerHealthRoute
  '/admin/deliveries': typeof AdminDeliveriesRoute
  '/admin/demo-requests': typeof AdminDemoRequestsRoute
  '/admin/features': typeof AdminFeaturesRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/front-door': typeof AdminFrontDoorRoute
  '/admin/learn': typeof AdminLearnRoute
  '/admin/learners': typeof AdminLearnersRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/support-requests': typeof AdminSupportRequestsRoute
  '/admin/templates': typeof AdminTemplatesRoute
  '/admin/upgrade-requests': typeof AdminUpgradeRequestsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/web-analytics': typeof AdminWebAnalyticsRoute
  '/analytics/$shareToken': typeof AnalyticsShareTokenRoute
  '/auth/action': typeof AuthActionRoute
  '/auth/extension': typeof AuthExtensionRoute
  '/billing/success': typeof BillingSuccessRoute
  '/blog/$shareToken': typeof BlogShareTokenRoute
  '/captures/$captureId': typeof CapturesCaptureIdRoute
  '/chat/$conversationId': typeof ChatConversationIdRouteWithChildren
  '/chat/$conversationId-enhanced': typeof ChatConversationIdEnhancedRoute
  '/developers/kubicle': typeof DevelopersKubicleRoute
  '/developers/quickstart': typeof DevelopersQuickstartRoute
  '/embed/$shareToken': typeof EmbedShareTokenRoute
  '/extension/privacy': typeof ExtensionPrivacyRoute
  '/learn/$shareToken': typeof LearnShareTokenRoute
  '/learn/feedback': typeof LearnFeedbackRoute
  '/learn/me': typeof LearnMeRoute
  '/learn/parent': typeof LearnParentRoute
  '/learn/profile': typeof LearnProfileRoute
  '/learn/student': typeof LearnStudentRoute
  '/learn/teacher': typeof LearnTeacherRoute
  '/settings/advanced': typeof SettingsAdvancedRoute
  '/settings/api': typeof SettingsApiRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/team': typeof SettingsTeamRoute
  '/share/$shareToken': typeof ShareShareTokenRoute
  '/video/$shareToken': typeof VideoShareTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/learn/': typeof LearnIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/analytics/actors/$actorId': typeof AnalyticsActorsActorIdRoute
  '/chat/$conversationId/gallery': typeof ChatConversationIdGalleryRoute
  '/chat/$conversationId/slide-workspace': typeof ChatConversationIdSlideWorkspaceRoute
  '/chat/$conversationId/video-workspace': typeof ChatConversationIdVideoWorkspaceRoute
  '/learn/course/$courseId': typeof LearnCourseCourseIdRoute
  '/analytics/actors': typeof AnalyticsActorsIndexRoute
  '/chat/$conversationId/slide/$slideHash': typeof ChatConversationIdSlideSlideHashRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agent-chat': typeof AgentChatRoute
  '/billing': typeof BillingRouteWithChildren
  '/captures': typeof CapturesRoute
  '/developers': typeof DevelopersRoute
  '/landing': typeof LandingRoute
  '/login': typeof LoginRoute
  '/market-recap': typeof MarketRecapRoute
  '/organization': typeof OrganizationRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/refund': typeof RefundRoute
  '/signup-flow': typeof SignupFlowRoute
  '/start': typeof StartRoute
  '/styles': typeof StylesRoute
  '/teams': typeof TeamsRoute
  '/terms': typeof TermsRoute
  '/videos': typeof VideosRoute
  '/waitlist': typeof WaitlistRoute
  '/account/billing': typeof AccountBillingRoute
  '/admin/api-calls': typeof AdminApiCallsRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/broadcasts': typeof AdminBroadcastsRoute
  '/admin/classes': typeof AdminClassesRoute
  '/admin/customer-health': typeof AdminCustomerHealthRoute
  '/admin/deliveries': typeof AdminDeliveriesRoute
  '/admin/demo-requests': typeof AdminDemoRequestsRoute
  '/admin/features': typeof AdminFeaturesRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/front-door': typeof AdminFrontDoorRoute
  '/admin/learn': typeof AdminLearnRoute
  '/admin/learners': typeof AdminLearnersRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/support-requests': typeof AdminSupportRequestsRoute
  '/admin/templates': typeof AdminTemplatesRoute
  '/admin/upgrade-requests': typeof AdminUpgradeRequestsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/web-analytics': typeof AdminWebAnalyticsRoute
  '/analytics/$shareToken': typeof AnalyticsShareTokenRoute
  '/auth/action': typeof AuthActionRoute
  '/auth/extension': typeof AuthExtensionRoute
  '/billing/success': typeof BillingSuccessRoute
  '/blog/$shareToken': typeof BlogShareTokenRoute
  '/captures/$captureId': typeof CapturesCaptureIdRoute
  '/chat/$conversationId': typeof ChatConversationIdRouteWithChildren
  '/chat/$conversationId-enhanced': typeof ChatConversationIdEnhancedRoute
  '/developers/kubicle': typeof DevelopersKubicleRoute
  '/developers/quickstart': typeof DevelopersQuickstartRoute
  '/embed/$shareToken': typeof EmbedShareTokenRoute
  '/extension/privacy': typeof ExtensionPrivacyRoute
  '/learn/$shareToken': typeof LearnShareTokenRoute
  '/learn/feedback': typeof LearnFeedbackRoute
  '/learn/me': typeof LearnMeRoute
  '/learn/parent': typeof LearnParentRoute
  '/learn/profile': typeof LearnProfileRoute
  '/learn/student': typeof LearnStudentRoute
  '/learn/teacher': typeof LearnTeacherRoute
  '/settings/advanced': typeof SettingsAdvancedRoute
  '/settings/api': typeof SettingsApiRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/team': typeof SettingsTeamRoute
  '/share/$shareToken': typeof ShareShareTokenRoute
  '/video/$shareToken': typeof VideoShareTokenRoute
  '/admin': typeof AdminIndexRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/learn': typeof LearnIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/analytics/actors/$actorId': typeof AnalyticsActorsActorIdRoute
  '/chat/$conversationId/gallery': typeof ChatConversationIdGalleryRoute
  '/chat/$conversationId/slide-workspace': typeof ChatConversationIdSlideWorkspaceRoute
  '/chat/$conversationId/video-workspace': typeof ChatConversationIdVideoWorkspaceRoute
  '/learn/course/$courseId': typeof LearnCourseCourseIdRoute
  '/analytics/actors': typeof AnalyticsActorsIndexRoute
  '/chat/$conversationId/slide/$slideHash': typeof ChatConversationIdSlideSlideHashRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/agent-chat': typeof AgentChatRoute
  '/analytics': typeof AnalyticsRouteWithChildren
  '/billing': typeof BillingRouteWithChildren
  '/captures': typeof CapturesRoute
  '/developers': typeof DevelopersRoute
  '/landing': typeof LandingRoute
  '/learn': typeof LearnRouteWithChildren
  '/login': typeof LoginRoute
  '/market-recap': typeof MarketRecapRoute
  '/organization': typeof OrganizationRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/refund': typeof RefundRoute
  '/settings': typeof SettingsRouteWithChildren
  '/signup-flow': typeof SignupFlowRoute
  '/start': typeof StartRoute
  '/styles': typeof StylesRoute
  '/teams': typeof TeamsRoute
  '/terms': typeof TermsRoute
  '/videos': typeof VideosRoute
  '/waitlist': typeof WaitlistRoute
  '/account/billing': typeof AccountBillingRoute
  '/admin/api-calls': typeof AdminApiCallsRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/broadcasts': typeof AdminBroadcastsRoute
  '/admin/classes': typeof AdminClassesRoute
  '/admin/customer-health': typeof AdminCustomerHealthRoute
  '/admin/deliveries': typeof AdminDeliveriesRoute
  '/admin/demo-requests': typeof AdminDemoRequestsRoute
  '/admin/features': typeof AdminFeaturesRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/front-door': typeof AdminFrontDoorRoute
  '/admin/learn': typeof AdminLearnRoute
  '/admin/learners': typeof AdminLearnersRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/support-requests': typeof AdminSupportRequestsRoute
  '/admin/templates': typeof AdminTemplatesRoute
  '/admin/upgrade-requests': typeof AdminUpgradeRequestsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/web-analytics': typeof AdminWebAnalyticsRoute
  '/analytics/$shareToken': typeof AnalyticsShareTokenRoute
  '/auth/action': typeof AuthActionRoute
  '/auth/extension': typeof AuthExtensionRoute
  '/billing/success': typeof BillingSuccessRoute
  '/blog/$shareToken': typeof BlogShareTokenRoute
  '/captures_/$captureId': typeof CapturesCaptureIdRoute
  '/chat/$conversationId': typeof ChatConversationIdRouteWithChildren
  '/chat/$conversationId-enhanced': typeof ChatConversationIdEnhancedRoute
  '/developers_/kubicle': typeof DevelopersKubicleRoute
  '/developers_/quickstart': typeof DevelopersQuickstartRoute
  '/embed/$shareToken': typeof EmbedShareTokenRoute
  '/extension/privacy': typeof ExtensionPrivacyRoute
  '/learn/$shareToken': typeof LearnShareTokenRoute
  '/learn/feedback': typeof LearnFeedbackRoute
  '/learn/me': typeof LearnMeRoute
  '/learn/parent': typeof LearnParentRoute
  '/learn/profile': typeof LearnProfileRoute
  '/learn/student': typeof LearnStudentRoute
  '/learn/teacher': typeof LearnTeacherRoute
  '/settings/advanced': typeof SettingsAdvancedRoute
  '/settings/api': typeof SettingsApiRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/team': typeof SettingsTeamRoute
  '/share/$shareToken': typeof ShareShareTokenRoute
  '/video/$shareToken': typeof VideoShareTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/learn/': typeof LearnIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/analytics/actors/$actorId': typeof AnalyticsActorsActorIdRoute
  '/chat/$conversationId/gallery': typeof ChatConversationIdGalleryRoute
  '/chat/$conversationId/slide-workspace': typeof ChatConversationIdSlideWorkspaceRoute
  '/chat/$conversationId/video-workspace': typeof ChatConversationIdVideoWorkspaceRoute
  '/learn/course/$courseId': typeof LearnCourseCourseIdRoute
  '/analytics/actors/': typeof AnalyticsActorsIndexRoute
  '/chat/$conversationId/slide/$slideHash': typeof ChatConversationIdSlideSlideHashRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/agent-chat'
    | '/analytics'
    | '/billing'
    | '/captures'
    | '/developers'
    | '/landing'
    | '/learn'
    | '/login'
    | '/market-recap'
    | '/organization'
    | '/pricing'
    | '/privacy'
    | '/profile'
    | '/refund'
    | '/settings'
    | '/signup-flow'
    | '/start'
    | '/styles'
    | '/teams'
    | '/terms'
    | '/videos'
    | '/waitlist'
    | '/account/billing'
    | '/admin/api-calls'
    | '/admin/billing'
    | '/admin/broadcasts'
    | '/admin/classes'
    | '/admin/customer-health'
    | '/admin/deliveries'
    | '/admin/demo-requests'
    | '/admin/features'
    | '/admin/feedback'
    | '/admin/front-door'
    | '/admin/learn'
    | '/admin/learners'
    | '/admin/organizations'
    | '/admin/support-requests'
    | '/admin/templates'
    | '/admin/upgrade-requests'
    | '/admin/users'
    | '/admin/web-analytics'
    | '/analytics/$shareToken'
    | '/auth/action'
    | '/auth/extension'
    | '/billing/success'
    | '/blog/$shareToken'
    | '/captures/$captureId'
    | '/chat/$conversationId'
    | '/chat/$conversationId-enhanced'
    | '/developers/kubicle'
    | '/developers/quickstart'
    | '/embed/$shareToken'
    | '/extension/privacy'
    | '/learn/$shareToken'
    | '/learn/feedback'
    | '/learn/me'
    | '/learn/parent'
    | '/learn/profile'
    | '/learn/student'
    | '/learn/teacher'
    | '/settings/advanced'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/profile'
    | '/settings/team'
    | '/share/$shareToken'
    | '/video/$shareToken'
    | '/admin/'
    | '/analytics/'
    | '/learn/'
    | '/settings/'
    | '/analytics/actors/$actorId'
    | '/chat/$conversationId/gallery'
    | '/chat/$conversationId/slide-workspace'
    | '/chat/$conversationId/video-workspace'
    | '/learn/course/$courseId'
    | '/analytics/actors'
    | '/chat/$conversationId/slide/$slideHash'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agent-chat'
    | '/billing'
    | '/captures'
    | '/developers'
    | '/landing'
    | '/login'
    | '/market-recap'
    | '/organization'
    | '/pricing'
    | '/privacy'
    | '/profile'
    | '/refund'
    | '/signup-flow'
    | '/start'
    | '/styles'
    | '/teams'
    | '/terms'
    | '/videos'
    | '/waitlist'
    | '/account/billing'
    | '/admin/api-calls'
    | '/admin/billing'
    | '/admin/broadcasts'
    | '/admin/classes'
    | '/admin/customer-health'
    | '/admin/deliveries'
    | '/admin/demo-requests'
    | '/admin/features'
    | '/admin/feedback'
    | '/admin/front-door'
    | '/admin/learn'
    | '/admin/learners'
    | '/admin/organizations'
    | '/admin/support-requests'
    | '/admin/templates'
    | '/admin/upgrade-requests'
    | '/admin/users'
    | '/admin/web-analytics'
    | '/analytics/$shareToken'
    | '/auth/action'
    | '/auth/extension'
    | '/billing/success'
    | '/blog/$shareToken'
    | '/captures/$captureId'
    | '/chat/$conversationId'
    | '/chat/$conversationId-enhanced'
    | '/developers/kubicle'
    | '/developers/quickstart'
    | '/embed/$shareToken'
    | '/extension/privacy'
    | '/learn/$shareToken'
    | '/learn/feedback'
    | '/learn/me'
    | '/learn/parent'
    | '/learn/profile'
    | '/learn/student'
    | '/learn/teacher'
    | '/settings/advanced'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/profile'
    | '/settings/team'
    | '/share/$shareToken'
    | '/video/$shareToken'
    | '/admin'
    | '/analytics'
    | '/learn'
    | '/settings'
    | '/analytics/actors/$actorId'
    | '/chat/$conversationId/gallery'
    | '/chat/$conversationId/slide-workspace'
    | '/chat/$conversationId/video-workspace'
    | '/learn/course/$courseId'
    | '/analytics/actors'
    | '/chat/$conversationId/slide/$slideHash'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/agent-chat'
    | '/analytics'
    | '/billing'
    | '/captures'
    | '/developers'
    | '/landing'
    | '/learn'
    | '/login'
    | '/market-recap'
    | '/organization'
    | '/pricing'
    | '/privacy'
    | '/profile'
    | '/refund'
    | '/settings'
    | '/signup-flow'
    | '/start'
    | '/styles'
    | '/teams'
    | '/terms'
    | '/videos'
    | '/waitlist'
    | '/account/billing'
    | '/admin/api-calls'
    | '/admin/billing'
    | '/admin/broadcasts'
    | '/admin/classes'
    | '/admin/customer-health'
    | '/admin/deliveries'
    | '/admin/demo-requests'
    | '/admin/features'
    | '/admin/feedback'
    | '/admin/front-door'
    | '/admin/learn'
    | '/admin/learners'
    | '/admin/organizations'
    | '/admin/support-requests'
    | '/admin/templates'
    | '/admin/upgrade-requests'
    | '/admin/users'
    | '/admin/web-analytics'
    | '/analytics/$shareToken'
    | '/auth/action'
    | '/auth/extension'
    | '/billing/success'
    | '/blog/$shareToken'
    | '/captures_/$captureId'
    | '/chat/$conversationId'
    | '/chat/$conversationId-enhanced'
    | '/developers_/kubicle'
    | '/developers_/quickstart'
    | '/embed/$shareToken'
    | '/extension/privacy'
    | '/learn/$shareToken'
    | '/learn/feedback'
    | '/learn/me'
    | '/learn/parent'
    | '/learn/profile'
    | '/learn/student'
    | '/learn/teacher'
    | '/settings/advanced'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/profile'
    | '/settings/team'
    | '/share/$shareToken'
    | '/video/$shareToken'
    | '/admin/'
    | '/analytics/'
    | '/learn/'
    | '/settings/'
    | '/analytics/actors/$actorId'
    | '/chat/$conversationId/gallery'
    | '/chat/$conversationId/slide-workspace'
    | '/chat/$conversationId/video-workspace'
    | '/learn/course/$courseId'
    | '/analytics/actors/'
    | '/chat/$conversationId/slide/$slideHash'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AgentChatRoute: typeof AgentChatRoute
  AnalyticsRoute: typeof AnalyticsRouteWithChildren
  BillingRoute: typeof BillingRouteWithChildren
  CapturesRoute: typeof CapturesRoute
  DevelopersRoute: typeof DevelopersRoute
  LandingRoute: typeof LandingRoute
  LearnRoute: typeof LearnRouteWithChildren
  LoginRoute: typeof LoginRoute
  MarketRecapRoute: typeof MarketRecapRoute
  OrganizationRoute: typeof OrganizationRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  ProfileRoute: typeof ProfileRoute
  RefundRoute: typeof RefundRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  SignupFlowRoute: typeof SignupFlowRoute
  StartRoute: typeof StartRoute
  StylesRoute: typeof StylesRoute
  TeamsRoute: typeof TeamsRoute
  TermsRoute: typeof TermsRoute
  VideosRoute: typeof VideosRoute
  WaitlistRoute: typeof WaitlistRoute
  AccountBillingRoute: typeof AccountBillingRoute
  AuthActionRoute: typeof AuthActionRoute
  AuthExtensionRoute: typeof AuthExtensionRoute
  BlogShareTokenRoute: typeof BlogShareTokenRoute
  CapturesCaptureIdRoute: typeof CapturesCaptureIdRoute
  ChatConversationIdRoute: typeof ChatConversationIdRouteWithChildren
  ChatConversationIdEnhancedRoute: typeof ChatConversationIdEnhancedRoute
  DevelopersKubicleRoute: typeof DevelopersKubicleRoute
  DevelopersQuickstartRoute: typeof DevelopersQuickstartRoute
  EmbedShareTokenRoute: typeof EmbedShareTokenRoute
  ExtensionPrivacyRoute: typeof ExtensionPrivacyRoute
  ShareShareTokenRoute: typeof ShareShareTokenRoute
  VideoShareTokenRoute: typeof VideoShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/videos': {
      id: '/videos'
      path: '/videos'
      fullPath: '/videos'
      preLoaderRoute: typeof VideosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams': {
      id: '/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof TeamsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/styles': {
      id: '/styles'
      path: '/styles'
      fullPath: '/styles'
      preLoaderRoute: typeof StylesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup-flow': {
      id: '/signup-flow'
      path: '/signup-flow'
      fullPath: '/signup-flow'
      preLoaderRoute: typeof SignupFlowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refund': {
      id: '/refund'
      path: '/refund'
      fullPath: '/refund'
      preLoaderRoute: typeof RefundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization': {
      id: '/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof OrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/market-recap': {
      id: '/market-recap'
      path: '/market-recap'
      fullPath: '/market-recap'
      preLoaderRoute: typeof MarketRecapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn': {
      id: '/learn'
      path: '/learn'
      fullPath: '/learn'
      preLoaderRoute: typeof LearnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/landing': {
      id: '/landing'
      path: '/landing'
      fullPath: '/landing'
      preLoaderRoute: typeof LandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers': {
      id: '/developers'
      path: '/developers'
      fullPath: '/developers'
      preLoaderRoute: typeof DevelopersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/captures': {
      id: '/captures'
      path: '/captures'
      fullPath: '/captures'
      preLoaderRoute: typeof CapturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-chat': {
      id: '/agent-chat'
      path: '/agent-chat'
      fullPath: '/agent-chat'
      preLoaderRoute: typeof AgentChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/learn/': {
      id: '/learn/'
      path: '/'
      fullPath: '/learn/'
      preLoaderRoute: typeof LearnIndexRouteImport
      parentRoute: typeof LearnRoute
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/video/$shareToken': {
      id: '/video/$shareToken'
      path: '/video/$shareToken'
      fullPath: '/video/$shareToken'
      preLoaderRoute: typeof VideoShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$shareToken': {
      id: '/share/$shareToken'
      path: '/share/$shareToken'
      fullPath: '/share/$shareToken'
      preLoaderRoute: typeof ShareShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/team': {
      id: '/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof SettingsTeamRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/api': {
      id: '/settings/api'
      path: '/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof SettingsApiRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/advanced': {
      id: '/settings/advanced'
      path: '/advanced'
      fullPath: '/settings/advanced'
      preLoaderRoute: typeof SettingsAdvancedRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/learn/teacher': {
      id: '/learn/teacher'
      path: '/teacher'
      fullPath: '/learn/teacher'
      preLoaderRoute: typeof LearnTeacherRouteImport
      parentRoute: typeof LearnRoute
    }
    '/learn/student': {
      id: '/learn/student'
      path: '/student'
      fullPath: '/learn/student'
      preLoaderRoute: typeof LearnStudentRouteImport
      parentRoute: typeof LearnRoute
    }
    '/learn/profile': {
      id: '/learn/profile'
      path: '/profile'
      fullPath: '/learn/profile'
      preLoaderRoute: typeof LearnProfileRouteImport
      parentRoute: typeof LearnRoute
    }
    '/learn/parent': {
      id: '/learn/parent'
      path: '/parent'
      fullPath: '/learn/parent'
      preLoaderRoute: typeof LearnParentRouteImport
      parentRoute: typeof LearnRoute
    }
    '/learn/me': {
      id: '/learn/me'
      path: '/me'
      fullPath: '/learn/me'
      preLoaderRoute: typeof LearnMeRouteImport
      parentRoute: typeof LearnRoute
    }
    '/learn/feedback': {
      id: '/learn/feedback'
      path: '/feedback'
      fullPath: '/learn/feedback'
      preLoaderRoute: typeof LearnFeedbackRouteImport
      parentRoute: typeof LearnRoute
    }
    '/learn/$shareToken': {
      id: '/learn/$shareToken'
      path: '/$shareToken'
      fullPath: '/learn/$shareToken'
      preLoaderRoute: typeof LearnShareTokenRouteImport
      parentRoute: typeof LearnRoute
    }
    '/extension/privacy': {
      id: '/extension/privacy'
      path: '/extension/privacy'
      fullPath: '/extension/privacy'
      preLoaderRoute: typeof ExtensionPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/$shareToken': {
      id: '/embed/$shareToken'
      path: '/embed/$shareToken'
      fullPath: '/embed/$shareToken'
      preLoaderRoute: typeof EmbedShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers_/quickstart': {
      id: '/developers_/quickstart'
      path: '/developers/quickstart'
      fullPath: '/developers/quickstart'
      preLoaderRoute: typeof DevelopersQuickstartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers_/kubicle': {
      id: '/developers_/kubicle'
      path: '/developers/kubicle'
      fullPath: '/developers/kubicle'
      preLoaderRoute: typeof DevelopersKubicleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$conversationId-enhanced': {
      id: '/chat/$conversationId-enhanced'
      path: '/chat/$conversationId-enhanced'
      fullPath: '/chat/$conversationId-enhanced'
      preLoaderRoute: typeof ChatConversationIdEnhancedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$conversationId': {
      id: '/chat/$conversationId'
      path: '/chat/$conversationId'
      fullPath: '/chat/$conversationId'
      preLoaderRoute: typeof ChatConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/captures_/$captureId': {
      id: '/captures_/$captureId'
      path: '/captures/$captureId'
      fullPath: '/captures/$captureId'
      preLoaderRoute: typeof CapturesCaptureIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$shareToken': {
      id: '/blog/$shareToken'
      path: '/blog/$shareToken'
      fullPath: '/blog/$shareToken'
      preLoaderRoute: typeof BlogShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/success': {
      id: '/billing/success'
      path: '/success'
      fullPath: '/billing/success'
      preLoaderRoute: typeof BillingSuccessRouteImport
      parentRoute: typeof BillingRoute
    }
    '/auth/extension': {
      id: '/auth/extension'
      path: '/auth/extension'
      fullPath: '/auth/extension'
      preLoaderRoute: typeof AuthExtensionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/action': {
      id: '/auth/action'
      path: '/auth/action'
      fullPath: '/auth/action'
      preLoaderRoute: typeof AuthActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/$shareToken': {
      id: '/analytics/$shareToken'
      path: '/$shareToken'
      fullPath: '/analytics/$shareToken'
      preLoaderRoute: typeof AnalyticsShareTokenRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/admin/web-analytics': {
      id: '/admin/web-analytics'
      path: '/web-analytics'
      fullPath: '/admin/web-analytics'
      preLoaderRoute: typeof AdminWebAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/upgrade-requests': {
      id: '/admin/upgrade-requests'
      path: '/upgrade-requests'
      fullPath: '/admin/upgrade-requests'
      preLoaderRoute: typeof AdminUpgradeRequestsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/templates': {
      id: '/admin/templates'
      path: '/templates'
      fullPath: '/admin/templates'
      preLoaderRoute: typeof AdminTemplatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/support-requests': {
      id: '/admin/support-requests'
      path: '/support-requests'
      fullPath: '/admin/support-requests'
      preLoaderRoute: typeof AdminSupportRequestsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations': {
      id: '/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/learners': {
      id: '/admin/learners'
      path: '/learners'
      fullPath: '/admin/learners'
      preLoaderRoute: typeof AdminLearnersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/learn': {
      id: '/admin/learn'
      path: '/learn'
      fullPath: '/admin/learn'
      preLoaderRoute: typeof AdminLearnRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/front-door': {
      id: '/admin/front-door'
      path: '/front-door'
      fullPath: '/admin/front-door'
      preLoaderRoute: typeof AdminFrontDoorRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feedback': {
      id: '/admin/feedback'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AdminFeedbackRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/features': {
      id: '/admin/features'
      path: '/features'
      fullPath: '/admin/features'
      preLoaderRoute: typeof AdminFeaturesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/demo-requests': {
      id: '/admin/demo-requests'
      path: '/demo-requests'
      fullPath: '/admin/demo-requests'
      preLoaderRoute: typeof AdminDemoRequestsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/deliveries': {
      id: '/admin/deliveries'
      path: '/deliveries'
      fullPath: '/admin/deliveries'
      preLoaderRoute: typeof AdminDeliveriesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/customer-health': {
      id: '/admin/customer-health'
      path: '/customer-health'
      fullPath: '/admin/customer-health'
      preLoaderRoute: typeof AdminCustomerHealthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/classes': {
      id: '/admin/classes'
      path: '/classes'
      fullPath: '/admin/classes'
      preLoaderRoute: typeof AdminClassesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/broadcasts': {
      id: '/admin/broadcasts'
      path: '/broadcasts'
      fullPath: '/admin/broadcasts'
      preLoaderRoute: typeof AdminBroadcastsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/billing': {
      id: '/admin/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AdminBillingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/api-calls': {
      id: '/admin/api-calls'
      path: '/api-calls'
      fullPath: '/admin/api-calls'
      preLoaderRoute: typeof AdminApiCallsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/account/billing': {
      id: '/account/billing'
      path: '/account/billing'
      fullPath: '/account/billing'
      preLoaderRoute: typeof AccountBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/actors/': {
      id: '/analytics/actors/'
      path: '/actors'
      fullPath: '/analytics/actors'
      preLoaderRoute: typeof AnalyticsActorsIndexRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/learn/course/$courseId': {
      id: '/learn/course/$courseId'
      path: '/course/$courseId'
      fullPath: '/learn/course/$courseId'
      preLoaderRoute: typeof LearnCourseCourseIdRouteImport
      parentRoute: typeof LearnRoute
    }
    '/chat/$conversationId/video-workspace': {
      id: '/chat/$conversationId/video-workspace'
      path: '/video-workspace'
      fullPath: '/chat/$conversationId/video-workspace'
      preLoaderRoute: typeof ChatConversationIdVideoWorkspaceRouteImport
      parentRoute: typeof ChatConversationIdRoute
    }
    '/chat/$conversationId/slide-workspace': {
      id: '/chat/$conversationId/slide-workspace'
      path: '/slide-workspace'
      fullPath: '/chat/$conversationId/slide-workspace'
      preLoaderRoute: typeof ChatConversationIdSlideWorkspaceRouteImport
      parentRoute: typeof ChatConversationIdRoute
    }
    '/chat/$conversationId/gallery': {
      id: '/chat/$conversationId/gallery'
      path: '/gallery'
      fullPath: '/chat/$conversationId/gallery'
      preLoaderRoute: typeof ChatConversationIdGalleryRouteImport
      parentRoute: typeof ChatConversationIdRoute
    }
    '/analytics/actors/$actorId': {
      id: '/analytics/actors/$actorId'
      path: '/actors/$actorId'
      fullPath: '/analytics/actors/$actorId'
      preLoaderRoute: typeof AnalyticsActorsActorIdRouteImport
      parentRoute: typeof AnalyticsRoute
    }
    '/chat/$conversationId/slide/$slideHash': {
      id: '/chat/$conversationId/slide/$slideHash'
      path: '/slide/$slideHash'
      fullPath: '/chat/$conversationId/slide/$slideHash'
      preLoaderRoute: typeof ChatConversationIdSlideSlideHashRouteImport
      parentRoute: typeof ChatConversationIdRoute
    }
  }
}

interface AdminRouteChildren {
  AdminApiCallsRoute: typeof AdminApiCallsRoute
  AdminBillingRoute: typeof AdminBillingRoute
  AdminBroadcastsRoute: typeof AdminBroadcastsRoute
  AdminClassesRoute: typeof AdminClassesRoute
  AdminCustomerHealthRoute: typeof AdminCustomerHealthRoute
  AdminDeliveriesRoute: typeof AdminDeliveriesRoute
  AdminDemoRequestsRoute: typeof AdminDemoRequestsRoute
  AdminFeaturesRoute: typeof AdminFeaturesRoute
  AdminFeedbackRoute: typeof AdminFeedbackRoute
  AdminFrontDoorRoute: typeof AdminFrontDoorRoute
  AdminLearnRoute: typeof AdminLearnRoute
  AdminLearnersRoute: typeof AdminLearnersRoute
  AdminOrganizationsRoute: typeof AdminOrganizationsRoute
  AdminSupportRequestsRoute: typeof AdminSupportRequestsRoute
  AdminTemplatesRoute: typeof AdminTemplatesRoute
  AdminUpgradeRequestsRoute: typeof AdminUpgradeRequestsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminWebAnalyticsRoute: typeof AdminWebAnalyticsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminApiCallsRoute: AdminApiCallsRoute,
  AdminBillingRoute: AdminBillingRoute,
  AdminBroadcastsRoute: AdminBroadcastsRoute,
  AdminClassesRoute: AdminClassesRoute,
  AdminCustomerHealthRoute: AdminCustomerHealthRoute,
  AdminDeliveriesRoute: AdminDeliveriesRoute,
  AdminDemoRequestsRoute: AdminDemoRequestsRoute,
  AdminFeaturesRoute: AdminFeaturesRoute,
  AdminFeedbackRoute: AdminFeedbackRoute,
  AdminFrontDoorRoute: AdminFrontDoorRoute,
  AdminLearnRoute: AdminLearnRoute,
  AdminLearnersRoute: AdminLearnersRoute,
  AdminOrganizationsRoute: AdminOrganizationsRoute,
  AdminSupportRequestsRoute: AdminSupportRequestsRoute,
  AdminTemplatesRoute: AdminTemplatesRoute,
  AdminUpgradeRequestsRoute: AdminUpgradeRequestsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminWebAnalyticsRoute: AdminWebAnalyticsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AnalyticsRouteChildren {
  AnalyticsShareTokenRoute: typeof AnalyticsShareTokenRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  AnalyticsActorsActorIdRoute: typeof AnalyticsActorsActorIdRoute
  AnalyticsActorsIndexRoute: typeof AnalyticsActorsIndexRoute
}

const AnalyticsRouteChildren: AnalyticsRouteChildren = {
  AnalyticsShareTokenRoute: AnalyticsShareTokenRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  AnalyticsActorsActorIdRoute: AnalyticsActorsActorIdRoute,
  AnalyticsActorsIndexRoute: AnalyticsActorsIndexRoute,
}

const AnalyticsRouteWithChildren = AnalyticsRoute._addFileChildren(
  AnalyticsRouteChildren,
)

interface BillingRouteChildren {
  BillingSuccessRoute: typeof BillingSuccessRoute
}

const BillingRouteChildren: BillingRouteChildren = {
  BillingSuccessRoute: BillingSuccessRoute,
}

const BillingRouteWithChildren =
  BillingRoute._addFileChildren(BillingRouteChildren)

interface LearnRouteChildren {
  LearnShareTokenRoute: typeof LearnShareTokenRoute
  LearnFeedbackRoute: typeof LearnFeedbackRoute
  LearnMeRoute: typeof LearnMeRoute
  LearnParentRoute: typeof LearnParentRoute
  LearnProfileRoute: typeof LearnProfileRoute
  LearnStudentRoute: typeof LearnStudentRoute
  LearnTeacherRoute: typeof LearnTeacherRoute
  LearnIndexRoute: typeof LearnIndexRoute
  LearnCourseCourseIdRoute: typeof LearnCourseCourseIdRoute
}

const LearnRouteChildren: LearnRouteChildren = {
  LearnShareTokenRoute: LearnShareTokenRoute,
  LearnFeedbackRoute: LearnFeedbackRoute,
  LearnMeRoute: LearnMeRoute,
  LearnParentRoute: LearnParentRoute,
  LearnProfileRoute: LearnProfileRoute,
  LearnStudentRoute: LearnStudentRoute,
  LearnTeacherRoute: LearnTeacherRoute,
  LearnIndexRoute: LearnIndexRoute,
  LearnCourseCourseIdRoute: LearnCourseCourseIdRoute,
}

const LearnRouteWithChildren = LearnRoute._addFileChildren(LearnRouteChildren)

interface SettingsRouteChildren {
  SettingsAdvancedRoute: typeof SettingsAdvancedRoute
  SettingsApiRoute: typeof SettingsApiRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsTeamRoute: typeof SettingsTeamRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAdvancedRoute: SettingsAdvancedRoute,
  SettingsApiRoute: SettingsApiRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsTeamRoute: SettingsTeamRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface ChatConversationIdRouteChildren {
  ChatConversationIdGalleryRoute: typeof ChatConversationIdGalleryRoute
  ChatConversationIdSlideWorkspaceRoute: typeof ChatConversationIdSlideWorkspaceRoute
  ChatConversationIdVideoWorkspaceRoute: typeof ChatConversationIdVideoWorkspaceRoute
  ChatConversationIdSlideSlideHashRoute: typeof ChatConversationIdSlideSlideHashRoute
}

const ChatConversationIdRouteChildren: ChatConversationIdRouteChildren = {
  ChatConversationIdGalleryRoute: ChatConversationIdGalleryRoute,
  ChatConversationIdSlideWorkspaceRoute: ChatConversationIdSlideWorkspaceRoute,
  ChatConversationIdVideoWorkspaceRoute: ChatConversationIdVideoWorkspaceRoute,
  ChatConversationIdSlideSlideHashRoute: ChatConversationIdSlideSlideHashRoute,
}

const ChatConversationIdRouteWithChildren =
  ChatConversationIdRoute._addFileChildren(ChatConversationIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AgentChatRoute: AgentChatRoute,
  AnalyticsRoute: AnalyticsRouteWithChildren,
  BillingRoute: BillingRouteWithChildren,
  CapturesRoute: CapturesRoute,
  DevelopersRoute: DevelopersRoute,
  LandingRoute: LandingRoute,
  LearnRoute: LearnRouteWithChildren,
  LoginRoute: LoginRoute,
  MarketRecapRoute: MarketRecapRoute,
  OrganizationRoute: OrganizationRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  RefundRoute: RefundRoute,
  SettingsRoute: SettingsRouteWithChildren,
  SignupFlowRoute: SignupFlowRoute,
  StartRoute: StartRoute,
  StylesRoute: StylesRoute,
  TeamsRoute: TeamsRoute,
  TermsRoute: TermsRoute,
  VideosRoute: VideosRoute,
  WaitlistRoute: WaitlistRoute,
  AccountBillingRoute: AccountBillingRoute,
  AuthActionRoute: AuthActionRoute,
  AuthExtensionRoute: AuthExtensionRoute,
  BlogShareTokenRoute: BlogShareTokenRoute,
  CapturesCaptureIdRoute: CapturesCaptureIdRoute,
  ChatConversationIdRoute: ChatConversationIdRouteWithChildren,
  ChatConversationIdEnhancedRoute: ChatConversationIdEnhancedRoute,
  DevelopersKubicleRoute: DevelopersKubicleRoute,
  DevelopersQuickstartRoute: DevelopersQuickstartRoute,
  EmbedShareTokenRoute: EmbedShareTokenRoute,
  ExtensionPrivacyRoute: ExtensionPrivacyRoute,
  ShareShareTokenRoute: ShareShareTokenRoute,
  VideoShareTokenRoute: VideoShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
